module.exports = __webpack_public_path__ + "static/media/roger.98ac56d2.png";